import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Harga", -1)
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Tanggal Awal", -1)
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Tanggal Akhir", -1)
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Rute", -1)
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Versi Revisi", -1)
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "Keterangan", -1)
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_20 = { class: "container-btn-action" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import Calendar from 'primevue/calendar'
import { DatePicker } from 'v-calendar'
import { Form, Field, FieldArray, ErrorMessage } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, ref, reactive, getCurrentInstance, computed, watch } from 'vue'
import type { Ref } from 'vue'
import { IPriceForm } from '@/utils/interfaces/iPrice'
import IResponse from '@/utils/interfaces/iResponse'
import apiUseCase from '@/usecase/apiUseCase'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import moment from 'moment'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import { debounce, isNull } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const moduleStore = 'hjpDataList'
const endpointPrice = '/management/v1/MsPrice'
const endpointRoute = '/management/v1/MsRoute'

const store = useStore()
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const dataOptionRoute = ref([]) as any
const dataOptionPassenger = ref([]) as any
const dataForm = ref()
const idPrice = computed(() => store.state[moduleStore].modalForm.data?.Id)
const titleButton = ref('Simpan Harga')

let initialValues: IPriceForm = reactive({
  name: '',
  periodStart: moment().toDate(),
  periodEnd: moment().add(2, 'day').toDate(),
  route: null,
  version: null,
  description: null,
  isActive: true,
})

const schemaValidation = Yup.object().shape({
  name: Yup.string()
    .required('Nama Harga tidak boleh kosong')
    .max(30, 'Nama Harga maksimal 30 karakter')
    .matches(rgxExp.notSpaceInFirstChar, 'Nama Harga tidak valid!')
    .test('unique-name', 'Nama Harga sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpointPrice}${returnUrlPrams({
          search: val,
          filterField: ['name']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (idPrice.value) {
          return filterResult.length === 0 || val === initialValues.name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  periodStart: Yup.string().required('Tanggal awal tidak boleh kosong'),
  periodEnd: Yup.string().required('Tanggal akhir tidak boleh kosong'),
  route: Yup.object().required('Rute tidak boleh kosong'),
  // .when(['periodStart', 'periodEnd'], ([periodStart, periodEnd], schema) => {
  //   const afterCheck = schema.test('check-available', 'Rute sudah digunakan di harga lain', async (val: any) => {
  //     console.log('val', val)
  //     try {
  //       if (!isNull(periodStart) && !isNull(periodEnd)) {
  //         const { error } = await apiUseCase.get(`${endpointRoute}/Available-Route/${val.Id}`)
  //         return !error
  //       } return false
  //     } catch (error) {
  //       return false
  //     }
  //   })
  //   return afterCheck
  // }),
  version: Yup.string()
    .required('Versi Revisi tidak boleh kosong')
    .matches(rgxExp.notSpaceInFirstChar, 'Versi tidak valid!'),
})

const isLoading = ref(true)

const attrModalConfirmation = reactive({
  show: false,
  title: 'Simpan Harga?',
  subTitle: 'Pastikan data harga sudah benar dan sesuai dengan yang Anda inginkan.',
  btnSubmitTitle: titleButton.value,
  imgContent: require('@/assets/img/modal-confirmation/price-add-update.svg')
})

const onSubmit = (values: IPriceForm) => {
  store.dispatch('showLoading')
  dataForm.value = {
    Name: values.name,
    MsRouteId: values.route.value,
    PeriodStart: moment(values.periodStart).format('YYYY-MM-DD'),
    PeriodEnd: moment(values.periodEnd).format('YYYY-MM-DD'),
    Version: values.version,
    Description: values.description,
    IsActive: values.isActive,
    IsDelete: false
  }
  attrModalConfirmation.show = true
  store.dispatch('hideLoading')
}

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
}

const hideSidebar = () => {
  store.dispatch('setShowModalFormDl', false)
}

const onSubmitConfirmation = async () => {
  const toastMessage = idPrice.value ? 'Data berhasil diubah' : 'Data berhasil ditambahkan'
  const { result, error, message }: IResponse = await apiUseCase.postOrPut(endpointPrice, idPrice.value, dataForm.value)
  if (!error) {
    store.dispatch('setReloadDataList', true)
    hideSidebar()
    $toast.add({
      severity: 'success',
      detail: toastMessage,
      group: 'bc',
      closable: false,
      life: 3000
    })
    hideDialogConfirmation()
  } else {
    hideDialogConfirmation()
    $toast.add({
      severity: 'error',
      detail: message,
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
}

const getRoute = (search: string | null = null) => {
  apiUseCase.get(`${endpointRoute}${returnUrlPrams({
    search,
    filterField: ['code', 'name'],
    custom: [['activeOnly', '=', true], ['pageSize', '=', 100]]
  })}`).then((res: IResponse) => {
    dataOptionRoute.value = res.result.map((val: any) => ({
      ...val,
      label: `${val.Code}`,
      value: val.Id,
    }))
  })
}

const onSearchRoute = debounce(getRoute, 500)

const getDetailForm = async () => {
  const { result, error } = await apiUseCase.get(`${endpointPrice}/${idPrice.value}`)
  if (!error) {
    const mapData = {
      name: result.Name,
      route: {
        label: result.RouteName,
        value: result.MsRouteId
      },
      version: result.Version,
      periodStart: moment(result.PeriodStart).toDate(),
      periodEnd: moment(result.PeriodEnd).toDate(),
      description: result.Description,
      isActive: result.IsActive
    }
    console.log('mapData', mapData)
    initialValues = mapData
    console.log('initialValues', initialValues)
    isLoading.value = false
    console.log('isLoading', isLoading.value)
  }
}

const checkAddOrUpdate = () => {
  let titleForm = 'Tambah'
  if (idPrice.value) {
    titleForm = 'Edit'
    titleButton.value = 'Simpan Perubahan'
    attrModalConfirmation.title = 'Simpan Perubahan Harga?'
    attrModalConfirmation.subTitle = 'Pastikan data harga sudah benar dan sesuai dengan yang Anda inginkan'
    attrModalConfirmation.btnSubmitTitle = titleButton.value
    getDetailForm()
  } else {
    isLoading.value = false
  }
  store.dispatch('setTitleFormSidebar', `${titleForm} Harga`)
}

watch(() => isLoading.value, (val: boolean) => {
  if (val) {
    store.dispatch('showLoading')
  } else {
    store.dispatch('hideLoading')
  }
})

onMounted(() => {
  getRoute()
  checkAddOrUpdate()
  // getDetailForm(store.state[moduleStore].modal.data.Id)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoading.value)
      ? (_openBlock(), _createBlock(_unref(Form), {
          key: 0,
          onSubmit: onSubmit,
          "validation-schema": _unref(schemaValidation),
          "initial-values": _unref(initialValues),
          class: "form-container"
        }, {
          default: _withCtx(({ errors, setFieldValue, values }) => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_unref(Field), { name: "name" }, {
                default: _withCtx(({ field, handleChange, handleBlur }) => [
                  _createVNode(_unref(InputText), _mergeProps(field, {
                    onChange: handleChange,
                    onBlur: handleBlur,
                    class: `input-primary ${errors.corporateId ? 'input-invalid' : ''}`,
                    placeholder: "Tulis nama harga"
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_3, _toDisplayString(errors.name), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _hoisted_6,
                  _createVNode(_unref(Field), { name: "periodStart hidden-form" }, {
                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                      _createVNode(_unref(DatePicker), _mergeProps({
                        modelValue: values.periodStart,
                        "onUpdate:modelValue": ($event: any) => ((values.periodStart) = $event)
                      }, field, {
                        "onUpdate:modelValue": (val) => {
                if (val > values.periodEnd) {
                  setFieldValue('periodEnd', val)
                }
                setFieldValue('periodStart', val)
              },
                        masks: { input: 'DD/MM/YYYY' },
                        "min-date": _unref(moment)().toDate()
                      }), {
                        default: _withCtx(({ togglePopover, inputValue }) => [
                          _createVNode(_unref(InputText), {
                            id: "start-date",
                            "aria-describedby": "start-date-help",
                            placeholder: "DD/MM/YYYY",
                            value: inputValue,
                            class: _normalizeClass(`input-primary ${errors.periodStart ? 'input-invalid' : ''}`),
                            onClick: togglePopover,
                            readonly: ""
                          }, null, 8, ["value", "class", "onClick"])
                        ]),
                        _: 2
                      }, 1040, ["modelValue", "onUpdate:modelValue", "min-date"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(errors.periodStart), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_8,
                  _createVNode(_unref(Field), { name: "periodEnd hidden-form" }, {
                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                      _createVNode(_unref(DatePicker), _mergeProps({
                        modelValue: values.periodEnd,
                        "onUpdate:modelValue": ($event: any) => ((values.periodEnd) = $event)
                      }, field, {
                        "onUpdate:modelValue": (val) => {
                if (val < values.periodStart) {
                  setFieldValue('periodStart', val)
                }
                setFieldValue('periodEnd', val)
              },
                        masks: { input: 'DD/MM/YYYY' },
                        "min-date": values.periodStart
                      }), {
                        default: _withCtx(({ togglePopover, inputValue }) => [
                          _createVNode(_unref(InputText), {
                            id: "end-date",
                            "aria-describedby": "end-date-help",
                            placeholder: "DD/MM/YYYY",
                            value: inputValue,
                            class: _normalizeClass(`input-primary ${errors.periodEnd ? 'input-invalid' : ''}`),
                            onClick: togglePopover,
                            readonly: ""
                          }, null, 8, ["value", "class", "onClick"])
                        ]),
                        _: 2
                      }, 1040, ["modelValue", "onUpdate:modelValue", "min-date"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(errors.periodEnd), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_unref(Field), { name: "route" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(SelectFetch, _mergeProps(field, {
                    placeholder: 'Pilih Rute',
                    modelValue: field.value,
                    id: "route",
                    inputId: "route",
                    endpoint: "/management/v1/MsRoute",
                    classname: "select-primary",
                    searchCustom: [['activeOnly', '=', true]],
                    selectable: (v) => !v.HasPrice,
                    fieldLabel: (v) => v.Code,
                    clearable: false,
                    searchFields: ['code', 'name']
                  }), null, 16, ["modelValue", "selectable", "fieldLabel"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, _toDisplayString(errors.route), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_unref(Field), { name: "version" }, {
                default: _withCtx(( { field, handleChange, handleBlur } ) => [
                  _createVNode(_unref(InputText), _mergeProps( field , {
                    onChange:  handleChange ,
                    onBlur:  handleBlur ,
                    class:  `input-primary ${errors.version ? 'input-invalid' : ''}` ,
                    placeholder: "Tulis versi revisi",
                    type: "number",
                    min:  0 
                  }), null, 16, ["onChange", "onBlur", "class"])
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_15, _toDisplayString(errors.version), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_unref(Field), {
                name: "description",
                as: "textarea",
                placeholder: "Tulis Keterangan",
                class: "input-primary"
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_unref(Field), { name: "isActive" }, {
                default: _withCtx(({ field }) => [
                  _createVNode(_unref(InputSwitch), _mergeProps({ class: "input-success" }, field, {
                    modelValue: field.value,
                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                    inputId: "isactive"
                  }), null, 16, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                class: "btn-primary mr-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"]))
      : _createCommentVNode("", true),
    _createVNode(HjpCofirmModal, {
      show:  attrModalConfirmation.show ,
      imgContent:  attrModalConfirmation.imgContent ,
      title:  attrModalConfirmation.title ,
      subTitle:  attrModalConfirmation.subTitle ,
      btnSubmitTitle:  attrModalConfirmation.btnSubmitTitle ,
      onHideDialog:  hideDialogConfirmation ,
      onOnSubmit:  onSubmitConfirmation 
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
  ]))
}
}

})